import IconButton from '@mui/material/IconButton';
import { toastr } from 'react-redux-toastr';
import Modal from '@material-ui/core/Modal';
import { Button } from '@mui/material';
import API from '../../../../create/api';
import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import * as helper from '../../../../../helper/index';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

interface ReturnedToMerchantProps {
  parcels: Array<{
    id: number;
    addToBalance: boolean;
    returnToMerchant: boolean;
    status: string;
  }>;
  refreshParcel: () => void;
}

export default function ReturnedToMerchant({ parcels, refreshParcel }: ReturnedToMerchantProps) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = React.useState(false);

  const parcelIds = useMemo(
    () => parcels.filter((parcel) => !parcel.returnToMerchant).map((parcel) => parcel.id),
    [parcels],
  );

  async function Action() {
    setModalOpen(false);
    for (let i = 0; i < parcels.length; i++) {
      const { id, returnToMerchant, status } = parcels[i];

      if (returnToMerchant) {
        toastr.error('Parcel Updated', `Parcel ID:${id} Already Set to Return to Merchant`);
        continue;
      }

      if (status !== 'RETURNED') {
        toastr.error('Parcel Updated', `Parcel ID:${id} Status is not RETURNED`);
        continue;
      }

      await API.update(`${process.env.REACT_APP_API_SERVER}/parcels`, id, { returnToMerchant: true })
        .then((res) => {
          toastr.success('Parcel Updated', `Parcel ID:${id} Set to Return to Merchant`);
        })
        .catch((error) => {
          helper.axiosErrorHandling(error);
        });
    }
    refreshParcel();
  }

  function handleClose() {
    setModalOpen(false);
  }

  return (
    <>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={modalOpen}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{ timeout: 500 }}
      >
        <div className={classes.paper}>
          <h1 id="spring-modal-title">Return to Merchant</h1>
          <p id="spring-modal-description">
            Do you want to Return to Merchant {parcelIds.join(',')}
            <br />
            <Button color="secondary" onClick={Action}>
              Yes
            </Button>
            <Button color="primary" onClick={handleClose}>
              No
            </Button>
          </p>
        </div>
      </Modal>
      <IconButton
        onClick={() => {
          setModalOpen(true);
        }}
      >
        <ArrowOutwardIcon style={{ color: '#2e7d32' }} />
      </IconButton>
    </>
  );
}
